import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { pageSize } from "common/constants/constants";
import { scrolToTop } from "common/utils/utilities";
import { usePermission } from "hooks/permission/usePermission";
import {
  MANAGE_BRANCHES,
  VIEW_BRANCHES,
} from "common/constants/permissionKeys";
import ActionBar from "components/common/tableFilters/ActionBar";
import TableCommon from "components/common/dynamicTable/DynamicTable";
import Loader from "components/common/loader/Loader";
import Paginate from "components/common/pagination/Paginate";
import NoDataFound from "components/common/noDataFound/NoDataFound";
import { getBranchList } from "services/branchServices";
import { getProductList } from "services/ProductsServices";
import "pages/branches/branches.scss";
import "common/common.scss";

import { bGId } from "common/constants/constants";
import { useTranslation } from "react-i18next";

function Branches() {
  const { t, i18n } = useTranslation();
  const { checkPermission } = usePermission();
  const navigate = useNavigate();
  const [refresh, setRefresh] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [branchesList, setBranchesList] = useState([]);
  const [productList, setProductList] = useState([]);
  const [pagination, setPagination] = useState({});
  const [isEmpty, setIsEmpty] = useState(false);

  const [orderByList, setOrderByList] = useState(
    JSON.parse(localStorage.getItem("branches"))?.map((elem) => {
      return { value: elem.key, name: t("branches-sort." + elem.key) };
    }) || []
  );
  useEffect(() => {
    const handleLanguageChange = () => {
      setOrderByList(
        JSON.parse(localStorage.getItem("branches")).map((elem) => {
          return { value: elem.key, name: t("branches-sort." + elem.key) };
        })
      );
    };

    i18n.on("languageChanged", handleLanguageChange);

    return () => {
      i18n.off("languageChanged", handleLanguageChange);
    };
  }, [i18n]);
  const [filters, setFilters] = useState({
    searchString: "",
    orderBy: "",
    products: [],

    orderType: "DESC",
  });
  const handleRefresh = () => {
    setRefresh((pre) => !pre);
    setIsLoading(true);
  };
  const permissionToManageBranch = checkPermission(MANAGE_BRANCHES);
  const permissionToViewBranch = checkPermission(VIEW_BRANCHES);
  const heading = [
    t("branch-name"),
    t("users"),
    t("gecco-type"),
    t("fc-type"),
    // t("balance-total-h1"),
    t("questionnaire-count"),
    t("products-owned"),
    t("details"),
    t("actions"),
  ];
  const nestedColumns = [
    {
      title: t("branch-name"),
    },
    {
      title: t("users"),
    },
    {
      title: t("gecco-type"),
      children: [
        { title: t("gecco2.registered-users") },
        { title: t("gecco2.basic-plan-users") },
        { title: t("gecco2.premium-plan-users") },
        { title: t("gecco2.pro-plan-users") },
      ],
    },
    {
      title: t("fc-type"),
    },
    {
      title: t("questionnaire-count"),
    },
    {
      title: t("products-owned"),
    },
    {
      title: t("details"),
    },
    {
      title: t("actions"),
    },
    // {
    //   title: "Activity",
    //   children: [{ title: "Last Activity" }, { title: "Status" }],
    // },
  ];

  const handleChangeFilters = (key, value) => {
    setPagination((pre) => {
      return { ...pre, currentPage: 1 };
    });
    setFilters((pre) => {
      let obj = { ...pre };
      obj[key] = value;
      return obj;
    });
  };
  const handleNextPage = (data) => {
    const { selected } = data;
    setPagination((pre) => {
      return { ...pre, currentPage: selected + 1 };
    });
    handleRefresh();
  };
  const handleSetBranches = async () => {
    setIsLoading(true);
    let pathIds = {
      bankId: "92e67d45-b4d4-4710-a6b9-bde2b5de5b5a",
      bankgroupsId: bGId,
    };
    let params = {
      pageSize,
      pageNumber: pagination.currentPage,
      ...filters,
    };
    params.orderBy = filters.orderBy || "UserCount";
    params.orderType = filters.orderType || "DESC";

    scrolToTop();

    let result = await getBranchList(pathIds, params);
    if (result?.success) {
      if (result.payLoad.items.length === 0) {
        setIsLoading(false);
        setIsEmpty(true);
      } else {
        const { totalCount, pageSize, totalPages, currentPage, items } =
          result?.payLoad || {};
        setIsEmpty(false);
        debugger;
        console.log(items);
        setBranchesList(items);
        setPagination({ totalCount, pageSize, totalPages, currentPage });
        setIsLoading(false);
      }
    } else if (result?.status === 422) {
      setIsLoading(false);
      setIsEmpty(true);
    }
  };
  const getProductsList = async () => {
    const result = await getProductList();
    setProductList(result?.payLoad?.items);
  };
  const handleResetFilters = () => {
    setFilters({
      orderType: "DESC",
      searchString: "",
      orderBy: "",
      products: [],
    });
  };
  useEffect(() => {
    getProductsList();
  }, []);
  useEffect(() => {
    handleSetBranches();
  }, [
    refresh,
    filters.orderBy,
    filters.orderType,
    filters.searchString,
    filters.products,
  ]);
  return (
    <div className="main">
      <div className="custom-breadcrumbs ">
        <span
          className="breadcrumbs-item "
          onClick={() => {
            navigate("/branches");
          }}
        >
          {t("branches")}
        </span>
      </div>
      {permissionToViewBranch && (
        <>
          <ActionBar
            handleChange={handleChangeFilters}
            handleSubmit={handleRefresh}
            productList={productList}
            filters={filters}
            orderByList={orderByList}
            resetFilters={handleResetFilters}
            searchPlaceholder={t("branch-name-or-location")}
            showAddButton={permissionToManageBranch}
            text={t("add-new-branch")}
            path="/branches/add-branch"
            show={true}
          />
          {isLoading ? (
            <Loader />
          ) : !isEmpty ? (
            <>
              <TableCommon
                heading={nestedColumns}
                name="branches"
                body={branchesList}
                permissionToEdit={permissionToManageBranch}
                tableStyle={{
                  minHeight: "40vh",
                  maxHeight: "56vh",
                }}
              />
              <Paginate
                totalPages={pagination.totalPages}
                handleNextPage={handleNextPage}
                currentPage={pagination.currentPage}
              />
            </>
          ) : (
            <NoDataFound />
          )}
        </>
      )}
    </div>
  );
}

export default Branches;
